import React, { memo } from 'react';

import './FieldInfo.css';

type FieldInfoProps = {
  label: string;
  value: string;
  onAction?: () => void;
  actionLabel?: string;
};

export const FieldInfo: React.FC<FieldInfoProps> = memo(
  ({ value, onAction, label, actionLabel }) => {
    return (
      <div className="field-info--container">
        <h2 className="field-info--label">{label}</h2>
        <p className="field-info--value">{value}</p>
        {onAction && (
          <a onClick={onAction} className="link">
            {actionLabel}
          </a>
        )}
      </div>
    );
  }
);
